<div class="dark_arousol_outer">
	<a [routerLink]="['story']" [queryParams]="{category: storyPreviewForDark[0].storyContentCategory.storyContentType}">
		<h1 class="heading">
			ALL {{storyPreviewForDark[0].storyContentCategory.storyContentType}}
		</h1>
	</a>
	<div class="page-container for_home_slider">
		<div class="carousel_container single_carousol dark_arousol">
			<owl-carousel-o [options]="customOptions">

				<ng-container *ngFor="let story of storyPreviewForDark; let i = index">
					<ng-container *ngIf="5>i">
						<ng-template carouselSlide>
							<div class="swiper-slide-container">
								<div class="slide_individual_home_banner">
									<!-- <div class="carousel_container_inner reflect">  for reflection-->
									<div class="carousel_container_inner">
										<div class="text_container">
											<h2>
												<span>{{story.title}}</span>
												<img class="motif" src="./assets/img/homepageectionsartwork-04.svg">
											</h2>
											<p [innerHTML]="story.description"></p>
											<button [routerLink]="['story-details/'+story.slug+'/'+story.id]"> Discover
												More</button>
										</div>
										<div class="image_container">
											<div class="image_overlay"></div>
											<div class="desktop_image_viewer" [ngStyle]="{'background': 'url(' + story.bannerImageDesktop + ') ' +
                                              'no-repeat 0 0 / cover'}">
											</div>
											<img class="mobile_image" src="{{story.bannerImageMobile}}"
												alt="{{story.title}}" />

											<!-- <div class="motif_cont">
													<img src="./assets/img/dark_section_bottom.svg" alt=""/>
												 </div> -->
										</div>
									</div>
								</div>
							</div>
						</ng-template>
					</ng-container>
				</ng-container>
			</owl-carousel-o>
		</div>
	</div>
</div>
